import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";

export function BodyFatFaq() {
  return (
    <section
      id="sss"
      aria-labelledby="faq-heading"
      className="mx-auto w-full max-w-[40rem] scroll-mt-28 py-12"
    >
      <div className="space-y-8">
        <header>
          <h2 id="faq-heading" className="font-bold text-3xl">
            Sık Sorulan Sorular
          </h2>
          <p className="mt-4 text-muted-foreground text-sm leading-6">
            Yöntem seçimi, ölçüm farkları ve sonuçlarını yorumlama hakkında.
          </p>
        </header>
        <Accordion type="single" collapsible className="w-full">
          <AccordionItem
            className="[&_[data-slot=accordion-content][data-state=closed]]:hidden"
            value="faq-1"
          >
            <AccordionTrigger className="py-6 font-medium text-base hover:no-underline">
              Sadece boy ve kiloyla yağ oranı hesaplanabilir mi?
            </AccordionTrigger>
            <AccordionContent
              forceMount
              className="prose prose-zinc dark:prose-invert max-w-none prose-a:text-primary text-base text-muted-foreground leading-7"
            >
              <p>
                Boy ve kilo BMI değerini verir. Deurenberg gibi yöntemler buna
                yaş ve cinsiyet ekleyerek yağ yüzdesi tahmin eder. Bu işlem
                doğrudan yağ ölçümü değildir.{" "}
                <a href="https://research.vu.nl/en/publications/body-mass-index-as-a-measure-of-body-fatness-age-and-sex-specific/">
                  Deurenberg araştırması
                </a>
              </p>
            </AccordionContent>
          </AccordionItem>
          <AccordionItem
            className="[&_[data-slot=accordion-content][data-state=closed]]:hidden"
            value="faq-2"
          >
            <AccordionTrigger className="py-6 font-medium text-base hover:no-underline">
              Mezuram var, kaliperim yok. Bu hesaplayıcıyı kullanabilir miyim?
            </AccordionTrigger>
            <AccordionContent
              forceMount
              className="prose prose-zinc dark:prose-invert max-w-none prose-a:text-primary text-base text-muted-foreground leading-7"
            >
              <p>
                Evet. Bu hesaplayıcı yalnızca mezurayla uygulanan Navy yöntemini
                kullanır. Boyun, karın veya bel ve gerekiyorsa kalça çevresini
                rehberdeki tarifle ölç; kaliper ölçüsü gerekmez.
              </p>
            </AccordionContent>
          </AccordionItem>
          <AccordionItem
            className="[&_[data-slot=accordion-content][data-state=closed]]:hidden"
            value="faq-3"
          >
            <AccordionTrigger className="py-6 font-medium text-base hover:no-underline">
              Navy yönteminde kilo ve yaş neden formülde yok?
            </AccordionTrigger>
            <AccordionContent
              forceMount
              className="prose prose-zinc dark:prose-invert max-w-none prose-a:text-primary text-base text-muted-foreground leading-7"
            >
              <p>
                Bu yazıda gösterilen Navy denklemi boy ve çevre ölçülerini
                kullanır. Kilo, bulunan yüzdeden yağ kütlesini kilogram olarak
                hesaplamak için gerekir. Bu nedenle hesaplayıcı yaş bilgisi
                istemez; kilo alanı isteğe bağlıdır.
              </p>
            </AccordionContent>
          </AccordionItem>
          <AccordionItem
            className="[&_[data-slot=accordion-content][data-state=closed]]:hidden"
            value="faq-4"
          >
            <AccordionTrigger className="py-6 font-medium text-base hover:no-underline">
              Kaliperle 7 bölge ölçmek her zaman daha doğru mu?
            </AccordionTrigger>
            <AccordionContent
              forceMount
              className="prose prose-zinc dark:prose-invert max-w-none prose-a:text-primary text-base text-muted-foreground leading-7"
            >
              <p>
                Yedi bölge ölçmek tek başına doğruluk garantisi vermez.
                Noktaların doğru bulunması, ölçüm tekniği ve denklemin kişiye
                uygunluğu da önemlidir. Yanlış alınan daha fazla ölçüm, otomatik
                olarak daha iyi tahmin oluşturmaz.{" "}
                <a href="https://pmc.ncbi.nlm.nih.gov/articles/PMC2891061/">
                  Jackson–Pollock denklemlerinin değerlendirilmesi
                </a>
              </p>
            </AccordionContent>
          </AccordionItem>
          <AccordionItem
            className="[&_[data-slot=accordion-content][data-state=closed]]:hidden"
            value="faq-5"
          >
            <AccordionTrigger className="py-6 font-medium text-base hover:no-underline">
              Akıllı tartım ile hesaplayıcı neden farklı sonuç veriyor?
            </AccordionTrigger>
            <AccordionContent
              forceMount
              className="prose prose-zinc dark:prose-invert max-w-none prose-a:text-primary text-base text-muted-foreground leading-7"
            >
              <p>
                Akıllı tartı BIA kullanıyorsa elektriksel özelliklerden; Navy
                çevre ölçülerinden; kaliper ise deri kıvrımından tahmin yapar.
                Yöntemler aynı veriyi kullanmaz. Türkiye’deki karşılaştırmalar
                da farklı yöntemlerin aynı kabul edilemeyeceğini gösterir.{" "}
                <a href="https://open.metu.edu.tr/handle/11511/48046">
                  Düz ve arkadaşları
                </a>
              </p>
            </AccordionContent>
          </AccordionItem>
          <AccordionItem
            className="[&_[data-slot=accordion-content][data-state=closed]]:hidden"
            value="faq-6"
          >
            <AccordionTrigger className="py-6 font-medium text-base hover:no-underline">
              Yağsız kütle, kas kütlesi midir?
            </AccordionTrigger>
            <AccordionContent
              forceMount
              className="prose prose-zinc dark:prose-invert max-w-none prose-a:text-primary text-base text-muted-foreground leading-7"
            >
              <p>
                Hayır. Yağsız kütle kasla birlikte su, kemik ve organlar gibi
                yağ dışı bileşenleri de içerir. Bu yüzden sonuç ekranındaki
                yağsız kütle değişimini doğrudan kazanılan veya kaybedilen kas
                miktarı olarak okuyamazsın.
              </p>
            </AccordionContent>
          </AccordionItem>
          <AccordionItem
            className="[&_[data-slot=accordion-content][data-state=closed]]:hidden"
            value="faq-7"
          >
            <AccordionTrigger className="py-6 font-medium text-base hover:no-underline">
              Yağ oranım bir günde değişti. Gerçekten yağ mı kaybettim?
            </AccordionTrigger>
            <AccordionContent
              forceMount
              className="prose prose-zinc dark:prose-invert max-w-none prose-a:text-primary text-base text-muted-foreground leading-7"
            >
              <p>
                Tek günlük hesaplayıcı farkı bunu kanıtlamaz. Önce ölçüm
                noktalarını ve koşullarını karşılaştır. Özellikle BIA sonucunda
                sıvı durumu da etkili olabilir.{" "}
                <a href="https://dergipark.org.tr/tr/download/article-file/4289756">
                  Acar ve arkadaşları
                </a>
              </p>
            </AccordionContent>
          </AccordionItem>
          <AccordionItem
            className="[&_[data-slot=accordion-content][data-state=closed]]:hidden"
            value="faq-8"
          >
            <AccordionTrigger className="py-6 font-medium text-base hover:no-underline">
              Çocuklarda ve hamilelikte bu hesaplayıcı kullanılabilir mi?
            </AccordionTrigger>
            <AccordionContent
              forceMount
              className="prose prose-zinc dark:prose-invert max-w-none prose-a:text-primary text-base text-muted-foreground leading-7"
            >
              <p>
                Yetişkinler için geliştirilmiş formülleri ve tabloları bu
                gruplara otomatik olarak uygulamamak gerekir. Jackson–Pollock
                çalışmalarının örneklemleri yetişkinlerden oluşur; burada
                formülleri aktarılan Navy araştırmasında da hamile ve emziren
                katılımcılar dışlanmıştır. Bu dönemlerde uygun değerlendirme
                yöntemini sağlık uzmanıyla belirlemek daha anlamlıdır.{" "}
                <a href="https://pubmed.ncbi.nlm.nih.gov/7402053/">
                  Jackson–Pollock
                </a>
                ,{" "}
                <a href="https://smj.sma.org.sg/5306/5306a7.pdf">
                  Navy formülünü kullanan araştırma
                </a>
              </p>
            </AccordionContent>
          </AccordionItem>
          <AccordionItem
            className="[&_[data-slot=accordion-content][data-state=closed]]:hidden"
            value="faq-9"
          >
            <AccordionTrigger className="py-6 font-medium text-base hover:no-underline">
              Yağ oranım %20 çıktı; bu iyi mi?
            </AccordionTrigger>
            <AccordionContent
              forceMount
              className="prose prose-zinc dark:prose-invert max-w-none prose-a:text-primary text-base text-muted-foreground leading-7"
            >
              <p>
                Yaşını, cinsiyetini, kullanılan yöntemi ve değerlendirme amacını
                bilmeden tek bir yüzdeye “iyi” veya “kötü” demek yeterli
                değildir. Önce ölçümünü doğrula; ardından sonucu uygun
                referansla ve zaman içindeki değişimle birlikte değerlendir.
              </p>
            </AccordionContent>
          </AccordionItem>
          <AccordionItem
            className="[&_[data-slot=accordion-content][data-state=closed]]:hidden"
            value="faq-10"
          >
            <AccordionTrigger className="py-6 font-medium text-base hover:no-underline">
              Sonucumu öğrendim, şimdi ne yapmalıyım?
            </AccordionTrigger>
            <AccordionContent
              forceMount
              className="prose prose-zinc dark:prose-invert max-w-none prose-a:text-primary text-base text-muted-foreground leading-7"
            >
              <p>
                Ölçülerini ve kullandığın yöntemi kaydet. Sonraki ölçümlerde
                aynı yöntemi ve noktaları kullan. Başlamak veya ölçülerini
                yeniden kontrol etmek için{" "}
                <a href="#hesaplayici">
                  AtalayTheCoach yağ oranı hesaplayıcısını aç
                </a>
                .
              </p>
            </AccordionContent>
          </AccordionItem>
        </Accordion>
      </div>
    </section>
  );
}
